import { render } from "./MyUserName.vue?vue&type=template&id=98f21984"
import script from "./MyUserName.vue?vue&type=script&lang=js"
export * from "./MyUserName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__